module.exports = __webpack_public_path__ + "img/03.dbebadc2.jpg";